import apiClient from '../lib/apiClient';

// Get all geo-fences
const getGeoFences = async (filters = {}) => {
  try {
    const result = await apiClient.get('/geo-fence', filters);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch geo-fences' };
  }
};

// Get single geo-fence
const getGeoFence = async (id) => {
  try {
    const result = await apiClient.get(`/geo-fence/${id}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch geo-fence' };
  }
};

// Create geo-fence
const createGeoFence = async (data) => {
  try {
    const result = await apiClient.post('/geo-fence', data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to create geo-fence' };
  }
};

// Update geo-fence
const updateGeoFence = async (id, data) => {
  try {
    const result = await apiClient.put(`/geo-fence/${id}`, data);
    console.log('Update geo-fence response:', result);
    if (result && (result.success !== false)) {
      return { success: true, data: result.data || result };
    }
    return { success: false, error: result?.error || result?.message || 'Failed to update geo-fence' };
  } catch (error) {
    console.error('Update geo-fence error:', error);
    return { success: false, error: error.message || 'Failed to update geo-fence' };
  }
};

// Delete geo-fence
const deleteGeoFence = async (id) => {
  try {
    const result = await apiClient.delete(`/geo-fence/${id}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to delete geo-fence' };
  }
};

// Verify location
const verifyLocation = async (latitude, longitude) => {
  try {
    const result = await apiClient.post('/geo-fence/verifyLocation', {
      latitude,
      longitude
    });
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to verify location' };
  }
};

export default {
  getGeoFences,
  getGeoFence,
  createGeoFence,
  updateGeoFence,
  deleteGeoFence,
  verifyLocation
};

